module.exports = __webpack_public_path__ + "img/BimiStock-ComingsoonMark.ac240733.png";